import { normalizeObject, dataLayerPush } from "../shared/utils";
// Search Initiated Event Handler
var searchInitiatedEventHandler = function (e) {
    var searchData = {};
    e && e.detail
        && Object.assign(searchData, normalizeObject(e.detail));
    // Event specific overwrites 
    Object.assign(searchData, {
        "event": "search",
        "event_action": "search_initiated",
        "event_category": "search",
        "non_interaction": false
    });
    dataLayerPush(searchData);
};
// Search Results View Event Handler
var searchResultsViewEventHandler = function (e) {
    var searchData = {};
    e && e.detail
        && Object.assign(searchData, normalizeObject(e.detail));
    // Event specific overwrites 
    Object.assign(searchData, {
        "event": "search_results",
        "event_action": "search_results_view",
        "event_category": "search",
        "non_interaction": true
    });
    dataLayerPush(searchData);
};
// Search Results Click Event Handler
var searchResultsClickEventHandler = function (e) {
    var searchData = {};
    e && e.detail
        && Object.assign(searchData, normalizeObject(e.detail));
    // Event specific overwrites 
    Object.assign(searchData, {
        "event": "search_results",
        "event_action": "search_results_click",
        "event_category": "search",
        "non_interaction": false
    });
    dataLayerPush(searchData);
};
// Search Filter Click Event Handler
var searchFilterClickEventHandler = function (e) {
    var searchData = {};
    e && e.detail
        && Object.assign(searchData, normalizeObject(e.detail));
    // Event specific overwrites 
    Object.assign(searchData, {
        "event": "search_filter_click",
        "event_action": "search_filter_click",
        "event_category": "search",
        "non_interaction": false
    });
    dataLayerPush(searchData);
};
// Search Filter Click Event Handler
var searchResultsErrorEventHandler = function (e) {
    var searchData = {};
    e
        && e.detail
        && Object.assign(searchData, normalizeObject(e.detail));
    // Event specific overwrites 
    Object.assign(searchData, {
        "event": "search_results",
        "event_action": "error_view",
        "non_interaction": false
    });
    dataLayerPush(searchData);
};
export { searchInitiatedEventHandler, searchResultsViewEventHandler, searchResultsClickEventHandler, searchFilterClickEventHandler, searchResultsErrorEventHandler };
